module.exports = __webpack_public_path__ + "img/39_34.45010613.png";